import { gql } from "@apollo/client";


export default gql`
    mutation signUpStaff($email: String!, $hospital_id: String!, $name: String!, $phoneNumber: String!) {
        insert_staffs_one(object: {email: $email, hospital_id: $hospital_id, name: $name, phoneNumber: $phoneNumber}) {
            id
        }
    }
`;